/* eslint-disable import/no-cycle */
import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import Icon, { IconNames } from 'components/icons'
import InputNumberElement from 'components/input-number-element'
import Message from 'components/message'
import { RadioGroupOnlyText } from 'components/radio-button'
import theme from 'components/theme'
import TitleContainer from 'components/title-container'
import e2eClass from 'helpers/automation'
import { arraysAreEqual, isEmpty } from 'helpers/utils'
import NAMESPACES from 'localization/constants/namespaces'
import {
  getMinPassengersByType,
  getMaxPassengersByType,
  getMaxPassengers,
  getMaxInfPerAdt
} from 'selectors/searchBoxRules'

import {
  Container,
  Header,
  HeaderText,
  HeaderClass,
  HeaderPassenger,
  ContentContainer,
  InputsNumberContainer,
  InputNumberTitle,
  InputNumberAge,
  ErrorContainer,
  OutsideErrorContainer,
  DisclaimerWrapper,
  DisclaimerText
} from './styled'

class ConfigPassenger extends Component {
  constructor(props) {
    super(props)

    const inputNumberValues = this.iterateInputNumber()

    this.state = {
      contentIsVisible: false,
      inputNumberValues,
      radioGroupValue:
        (this.props.radioGroupOptions.find(({ selected }) => selected) &&
          this.props.radioGroupOptions.find(({ selected }) => selected).value) ||
        0,
      passengerCount: this.addInputNumberValues(inputNumberValues) || 0
    }
  }

  getRadioGroupValue() {
    const selectedValue = this.props.radioGroupOptions.find(({ selected }) => selected)

    return selectedValue ? selectedValue.text : ''
  }

  iterateInputNumber = () => {
    const FIRST_ELEMENT_INDEX = 0
    const { restrictions } = this.props
    return this.props.inputsNumber.map(
      ({ id, value }) =>
        (restrictions &&
          restrictions[id.toUpperCase()] &&
          restrictions[id.toUpperCase()][FIRST_ELEMENT_INDEX]) ||
        value
    )
  }

  componentDidMount = () => {
    if (this.props.error) {
      this.contentVisibility(true)
    }
  }

  componentDidUpdate(prevProps) {
    if (isEmpty(prevProps.radioGroupOptions) && !isEmpty(this.props.radioGroupOptions)) {
      this.setState({
        radioGroupValue: this.props.radioGroupOptions[1]?.value
      })
    } else if (!arraysAreEqual(prevProps.radioGroupOptions, this.props.radioGroupOptions)) {
      this.setState({ radioGroupValue: this.getRadioGroupValue() })
    }

    if (prevProps.error && prevProps.error !== this.props.error) {
      this.contentVisibility(true)
    }
    if (prevProps.inputsNumber !== this.props.inputsNumber && isEmpty(this.props.restrictions)) {
      const inputNumberValues = this.iterateInputNumber()
      this.setState({
        passengerCount: this.addInputNumberValues(inputNumberValues) || 0,
        inputNumberValues: inputNumberValues
      })
    }
  }

  contentVisibility = contentIsVisible => {
    this.setState({ contentIsVisible })
  }

  switchContentVisibility = () => {
    this.setState(({ contentIsVisible }) => ({ contentIsVisible: !contentIsVisible }))
  }

  handleCabinChange = radioGroupValue => {
    this.setState({ radioGroupValue }, () => this.handleOnChange())
  }

  handleChangeInputNumber = (index, value) => {
    this.setState(
      ({ inputNumberValues }) => {
        const newInputNumberValues = [...inputNumberValues]
        newInputNumberValues[index] = value

        const newState = {
          inputNumberValues: newInputNumberValues,
          passengerCount: this.addInputNumberValues(newInputNumberValues)
        }

        return newState
      },
      () => this.handleOnChange()
    )
  }

  handleOnChange = () => {
    this.props.onChange({
      radioGroupValue: this.state.radioGroupValue,
      passengers: this.state.inputNumberValues
    })
  }

  addInputNumberValues = inputNumberValues =>
    Object.values(inputNumberValues).reduce((a, v) => a + v, 0)

  getQuantityByType(id) {
    const type = (this.props.inputsNumber || []).find(type => type.id === id)

    return type ? type.value : 0
  }

  isMinusButtonDisabled(index, value, id) {
    const { minPassengersByType, restrictions, maxInfPerAdt } = this.props
    const conditions = []

    if (restrictions && restrictions[id.toUpperCase()]) {
      const MIN_INDEX = 0
      const minPossibleValue = restrictions[id.toUpperCase()][MIN_INDEX]

      conditions.push(
        minPossibleValue === 0 ||
          (minPossibleValue === undefined && value === 0) ||
          minPossibleValue === value
      )
    } else {
      conditions.push(minPassengersByType[index] === value)
    }

    if (id === 'adt') {
      const adtValue = this.getQuantityByType('adt')
      const infValue = this.getQuantityByType('inf')
      if (restrictions && restrictions[id.toUpperCase()]) {
        const INDEX_OFFSET = 1
        const { inputNumberValues } = this.state
        const actualIndex = restrictions[id.toUpperCase()].findIndex(
          item => item === inputNumberValues[index]
        )
        const nextPossibleValue = restrictions[id.toUpperCase()][actualIndex - INDEX_OFFSET]

        conditions.push(nextPossibleValue < Math.ceil(infValue / maxInfPerAdt))
      } else {
        conditions.push(adtValue <= Math.ceil(infValue / maxInfPerAdt))
      }
    }

    return conditions.some(condition => condition)
  }

  isPlusButtonDisabled(index, value, id) {
    const { maxPassengers, maxPassengersByType, restrictions } = this.props
    const { inputNumberValues } = this.state
    const conditions = []

    if (restrictions && restrictions[id.toUpperCase()]) {
      const INDEX_OFFSET = 1
      const MAX_INDEX = restrictions[id.toUpperCase()].length - INDEX_OFFSET
      const maxPossibleValue = restrictions[id.toUpperCase()][MAX_INDEX]
      const actualIndex = restrictions[id.toUpperCase()].findIndex(
        item => item === inputNumberValues[index]
      )
      const nextPossibleValue = restrictions[id.toUpperCase()][actualIndex + INDEX_OFFSET]

      conditions.push(
        maxPossibleValue === 0 ||
          maxPossibleValue === value ||
          nextPossibleValue - inputNumberValues[index] + this.state.passengerCount > maxPassengers
      )
    } else {
      conditions.push(maxPassengersByType[index] === value)
    }

    conditions.push(this.state.passengerCount === maxPassengers)

    if (id === 'inf') {
      const adtValue = this.getQuantityByType('adt')
      const infValue = this.getQuantityByType('inf')

      conditions.push(infValue >= adtValue * this.props.maxInfPerAdt)
    }

    return conditions.some(condition => condition)
  }

  render() {
    const FIRST_ELEMENT_INDEX = 0
    const { restrictions } = this.props
    const iconName = this.state.contentIsVisible ? IconNames.ChevronUp : IconNames.ChevronDown
    const cabinValue = this.getRadioGroupValue()

    return (
      <Container
        ref={el => (this.input = el)}
        onBlur={e => {
          // currentTarget is the parent element, relatedTarget is the clicked element
          if (!e.currentTarget.contains(e.relatedTarget)) {
            this.contentVisibility(false)
          }
        }}
        tabIndex={-1}
        fullWidth={this.props.fullWidth}
        onKeyDown={e => {
          if (
            (e.key == 'Enter' && !this.state.contentIsVisible) ||
            (e.key == 'Escape' && this.state.contentIsVisible)
          ) {
            e.preventDefault()
            this.switchContentVisibility()
          }
        }}
        contentVisibility={this.state.contentIsVisible}
      >
        <Header
          error={this.props.error}
          focus={this.state.contentIsVisible}
          onClick={this.switchContentVisibility}
          flatStyle={this.props.flatStyle}
          id="cabin-passengers"
          aria-controls="cabin-passengers-list"
          aria-expanded={this.state.contentIsVisible}
        >
          <HeaderText>
            <HeaderPassenger value={this.state.passengerCount} error={this.props.error}>
              {`${this.state.passengerCount} ${this.props.t('label.passenger', {
                count: this.state.passengerCount
              })}`}
            </HeaderPassenger>
            <HeaderClass value={cabinValue}>{cabinValue && `, ${cabinValue}`}</HeaderClass>
          </HeaderText>
          <Icon name={IconNames[iconName]} size={23} color={theme.colors.blue} />
        </Header>
        <ContentContainer isVisible={this.state.contentIsVisible} id="cabin-passengers-list">
          <TitleContainer title={this.props.t('shopping.search-box.label.class')}>
            <RadioGroupOnlyText
              name={this.props.t('shopping.search-box.label.class')}
              options={this.props.radioGroupOptions}
              onChange={ev => this.handleCabinChange(ev.target.value) && ev.stopPropagation()}
              horizontal
              wrap
              fontSize={14}
            />
          </TitleContainer>
          <InputsNumberContainer>
            <TitleContainer title={this.props.t('label.passenger', { count: 2 })}>
              {this.props.inputsNumber.map(({ id, title, age, value }, index) => (
                <InputNumberElement
                  mainLabel={<InputNumberTitle>{title}</InputNumberTitle>}
                  secondLabel={<InputNumberAge>{age}</InputNumberAge>}
                  border
                  key={index}
                  id={id}
                  e2eClass={e2eClass('searchBox.passenger')}
                  onChange={input => this.handleChangeInputNumber(index, input.value)}
                  restrictions={restrictions}
                  value={
                    (!isEmpty(restrictions) &&
                      restrictions[id.toUpperCase()] &&
                      restrictions[id.toUpperCase()][FIRST_ELEMENT_INDEX]) ||
                    value
                  }
                  isMinusButtonDisabled={this.isMinusButtonDisabled(index, value, id)}
                  isPlusButtonDisabled={this.isPlusButtonDisabled(index, value, id)}
                />
              ))}
              <DisclaimerWrapper>
                <Icon name={IconNames.Dialog} color={theme.colors.gray} size={50} />
                <DisclaimerText>
                  {this.props.t('shopping.search-box.passengers-disclaimer', {
                    maxPassengers: this.props.maxPassengers,
                    passengerLabel: this.props.t('label.passenger', {
                      count: this.props.maxPassengers
                    }),
                    maxInfPerAdt: this.props.maxInfPerAdt,
                    babyLabel: this.props.t('shopping.search-box.passengers-disclaimer.baby', {
                      count: this.props.maxInfPerAdt
                    })
                  })}
                </DisclaimerText>
              </DisclaimerWrapper>
            </TitleContainer>
          </InputsNumberContainer>
          {this.props.error && (
            <ErrorContainer>
              <Message type="formInputError">{this.props.error}</Message>
            </ErrorContainer>
          )}
        </ContentContainer>
        {this.props.error && !this.state.contentIsVisible && (
          <OutsideErrorContainer>
            <Message type="formInputError">{this.props.error}</Message>
          </OutsideErrorContainer>
        )}
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  minPassengersByType: getMinPassengersByType(state),
  maxPassengersByType: getMaxPassengersByType(state),
  maxPassengers: getMaxPassengers(state),
  maxInfPerAdt: getMaxInfPerAdt(state)
})

export default withTranslation(NAMESPACES.SEARCH_BOX)(connect(mapStateToProps)(ConfigPassenger))
